import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const u = localStorage.getItem("ml_user");
    return u ? JSON.parse(u) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("ml_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => {
        const u = res.data;
        setUser(u);
        localStorage.setItem("ml_user", JSON.stringify(u));
      })
      .catch(() => {
        localStorage.removeItem("ml_token");
        localStorage.removeItem("ml_user");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password) => {
    const res = await api.post("/auth/login", { username, password });
    localStorage.setItem("ml_token", res.data.token);
    const u = res.data.user;
    localStorage.setItem("ml_user", JSON.stringify(u));
    setUser(u);
    return u;
  };

  const hasPerm = (key) => {
    if (!user) return false;
    if (user.is_admin) return true;
    return !!(user.permissions && user.permissions[key]);
  };

  const refreshUser = async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
      localStorage.setItem("ml_user", JSON.stringify(res.data));
    } catch {
      /* ignore */
    }
  };

  const logout = () => {
    localStorage.removeItem("ml_token");
    localStorage.removeItem("ml_user");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, loading, hasPerm, refreshUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
